class UpdateRoomCommand {

    constructor({roomId, roomName, isPrivateRoom}) {
        this.roomId=roomId;
        this.roomName=roomName;
        this.isPrivateRoom=isPrivateRoom
    }
}

export default UpdateRoomCommand;



// WEBPACK FOOTER //
// ./src/platform/chat/model/UpdateRoomCommand.js